import { SkeletonBlock } from './SekeletonBlock'

export default SkeletonBlock
